import {showSnackbar} from '@/app/shared-components/Snackbar/SnackbarProvider';
import {ISnackbarProps} from '@/app/shared-components/Snackbar/SnackbarTypes';
import {getErrorSchema} from '@/hooks/TrackingManager/utils/getErrorSchema';
import {IErrorEventDataSchema} from '@/services/segment/models/ErrorEventModel';

import {ErrorMessages} from './errorMessages';

export type ToastData = {TITLE: string; DETAILS: string};

export type ErrorMap = Record<string, ToastData>;

export const ErrorManager = {
  handleError: (
    error: any,
    options?: {
      customErrorMap?: ErrorMap;
      customDuration?: number;
    },
  ) => {
    const {customErrorMap, customDuration} = options || {};

    const showErrorToast = (props?: ISnackbarProps) => {
      showSnackbar({
        summary: props?.summary ?? ErrorMessages.default.TITLE,
        message: props?.message ?? ErrorMessages.default.DETAILS,
        autoHideDuration: customDuration,
      });
    };

    if (!error) {
      console.warn('ErrorManager: Received undefined or null error');
      showErrorToast();
      return;
    }

    const errorSchema: IErrorEventDataSchema = getErrorSchema(error) || null;
    const errorCode = errorSchema?.error?.code ?? error;
    const errorStatus = errorSchema?.error?.status ?? error;
    const errorModakMessage = errorSchema?.isModakError
      ? `${errorSchema?.error.message} (${errorSchema?.error.code})`
      : '';

    if (typeof errorCode !== 'string' && typeof errorCode !== 'number') {
      console.warn('ErrorManager: Invalid error code format', {
        error,
        errorCode,
      });
      showErrorToast();
      return;
    }

    const customError = customErrorMap?.[errorCode];

    if (customError) {
      showErrorToast({
        summary: customError.TITLE || 'Error',
        message: customError.DETAILS || 'An unexpected error occurred',
      });
      return;
    }

    const defaultError =
      ErrorMessages[String(errorStatus)] || ErrorMessages.default;

    showErrorToast({
      summary: defaultError.TITLE,
      message: errorModakMessage || defaultError.DETAILS,
    });
  },
};
